import script from "./AdminCreatePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCreatePopup.vue?vue&type=script&setup=true&lang=js"

import "./AdminCreatePopup.vue?vue&type=style&index=0&id=c39007a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c39007a6"]])

export default __exports__